import css from './Frame.module.css';
import classnames from 'classnames/bind';
import { Suspense, useEffect, useState, useContext, lazy } from 'react';
import { CatalogContext } from './Catalog.context';
import Scaler from './Scaler';
import Navigations from 'Navigation';

const cx = classnames.bind(css);

export default function Frame() {
  const {
    lang,
    pageNum,
    pageMap,
    activePageInfo,
    pagingSpeed,
    pagingDirection,
    autoplayRunning,
    isResponsiveMode,
  } = useContext(CatalogContext);

  const [Pages, setPages] = useState([]);

  useEffect(() => {
    setPages(prev => {
      const newArr = [];
      pageMap.forEach(item => {
        newArr.push(lazy(() => import(`/src/Pages/${item}`)));
      });
      return newArr;
    });
  }, [pageMap]);

  const activeClasses = () => {
    const classes = [`ct-page--${pageNum}`, `ct-lang--${lang}`];

    for (const key in activePageInfo) {
      const value = activePageInfo[key];
      const type = typeof value;

      if (!value || (type !== 'string' && type !== 'number')) continue;

      classes.push(`ct-${key}--${value}`);
    }

    classes.push(`ct-pagingDirection--${pagingDirection}`);
    classes.push(`ct-autoplayState--${autoplayRunning ? 'playing' : 'paused'}`);

    return classes.join(' ');
  };

  return (
    <div
      className={`${cx(
        'window',
        `${isResponsiveMode ? 'responsiveMode' : ''}`,
        activeClasses()
      )} ct-frame-window`}
    >
      <Scaler className={`${css.container} ct-frame-container`}>
        <div className={`${css.wrapper} ct-frame-wrapper`}>
          {Pages &&
            Pages.map((Page, i) => (
              <div
                key={`ct-page--key-${i}`}
                className={`${cx(
                  'page',
                  `${i === pageNum - 1 ? 'page--active' : ''}`
                )} ${classnames({
                  'ct-frame-page': true,
                  'pg--active': i === pageNum - 1,
                  'pg--prev': i === pageNum - 2,
                  'pg--next': i === pageNum,
                })}`}
                style={{ '--paging-speed': `${pagingSpeed}ms` }}
              >
                <Suspense>
                  <Page
                    isActive={i === pageNum - 1}
                    isPrev={i === pageNum - 2}
                    isNext={i === pageNum}
                  />
                </Suspense>
              </div>
            ))}
        </div>
        <Navigations />
      </Scaler>
    </div>
  );
}
